import React from "react";
import "./howWeWork.css";

function HowWeWorkArea() {
  return (
    <>
      <section className="how-we-work sec-mar-top">
        <div className="container">

          {/* TITLE */}
          <div className="row">
            <div className="col-md-8 col-xl-5">
              <div className="title black mb-4">
                <span>How We Work</span>
                <h2>Our Process to Deliver Results</h2>
              </div>
            </div>
          </div>

          {/* PROCESS STEPS */}
          <div className="row g-4 mt-4">

            <div className="col-md-6 col-lg-3">
              <div className="process-box">
                <span>01</span>
                <h4>Understanding</h4>
                <p>
                  We analyze your requirements, goals, and business needs to 
                  create a clear project roadmap.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="process-box">
                <span>02</span>
                <h4>Planning & Design</h4>
                <p>
                  We design user-focused experiences and define the structure 
                  for a scalable and efficient solution.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="process-box">
                <span>03</span>
                <h4>Development</h4>
                <p>
                  Our team builds high-performance solutions using modern 
                  technologies and best practices.
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-3">
              <div className="process-box">
                <span>04</span>
                <h4>Launch & Support</h4>
                <p>
                  We deploy, test, and continuously optimize to ensure long-term 
                  performance and growth.
                </p>
              </div>
            </div>

          </div>

        </div>
      </section>
    </>
  );
}

export default HowWeWorkArea;